<template>
  <div id="notification-widget">
    <div @click="setOpen()" class="button hidevalues notification-button" style="position:relative">
      <span style="display: inline-flex;align-content: end;align-items: center;"
        ><i class="far fa-bell" style="margin-right: 4px;"></i> <span>Notificações</span></span
      >
      <span
        v-if="notificationsToRead"
        style="background: rgb(234, 0, 0); border-radius: 100%; padding-left: 5px; padding-right: 5px; color: rgb(255, 255, 255); font-size: 12px; position: absolute; top: 0px; left: -3px;padding-top: 1px;padding-bottom: 1px;"
      >
        {{ notificationsToRead }}
      </span>
    </div>
    <div v-if="open">
      <div class="list">
        <ul>
          <li v-for="(notification, index) in notificationsRender" :key="index">
            <div
              class="notification flex"
              @click="
                open = false;
                openDetail = true;
                selectedNotificationId = notification.id;
              "
            >
              <div v-if="notification.type == 'AVATAR'" class="avatar">
                <img
                  src="@/assets/img/renanburda.jpeg"
                />
                <small>Renan Burda</small>
              </div>
              <div v-else class="avatar">
                <img src="@/assets/img/icon.png" />
                <small>Sistema</small>
              </div>
              <div class="content">
                <div v-if="notification.title" class="title">
                  {{ notification.title }}
                </div>
                <div
                  v-if="notification.description"
                  class="description"
                  v-html="
                    notification.description && notification.description.slice(0, 110) + '...'
                  "
                ></div>
                <div class="created">Há {{ formatDate(notification.created_at) | time }}</div>
              </div>
            </div>
          </li>
          <li v-if="!loader && notificationsRender && notificationsRender.length == 0">
            Parece que você não tem notificações
          </li>
          <li v-if="notificationsRender && notificationsRender.length" class="flex center">
            <div
              id="show-all-msgs"
              class="button secondary small"
              style="width:100%"
              @click="viewAllNotification()"
            >
              ver todas
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="openDetail">
      <div class="detail box">
        <div class="box-title flex between force-line">
          <h2>Notificações</h2>
          <div class="action">
            <div class="button secondary small" @click="closeDetail()">
              x
            </div>
          </div>
        </div>
        <!-- list  -->
        <div class="box-content grid-flex">
          <div class="flex-1">
            <div class="list-detail">
              <ul>
                <li
                  v-for="(notification, index) in notifications"
                  :key="index"
                  :class="{ active: selectedNotificationId === notification.id }"
                >
                  <div
                    class="notification flex"
                    @click="
                      open = false;
                      openDetail = true;
                      selectedNotificationId = notification.id;
                    "
                  >
                    <div v-if="notification.type == 'AVATAR'" class="avatar">
                      <img
                        src="@/assets/img/renanburda.jpeg"
                        />
                      <small>Renan Burda</small>
                    </div>
                    <div v-else class="avatar">
                      <img src="@/assets/img/icon.png" />
                      <small>Sistema</small>
                    </div>
                    <div class="content">
                      <div v-if="notification.title" class="title">
                        {{ notification.title }}
                      </div>
                      <div
                        v-if="notification.description"
                        class="description"
                        v-html="
                          notification.description && notification.description.slice(0, 120) + '...'
                        "
                      ></div>
                      <div class="created">Há {{ formatDate(notification.created_at) | time }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="!loader && notifications && notifications.length == 0">
                  Parece que você não tem notificações
                </li>
              </ul>
            </div>
          </div>
          <!-- detail -->
          <div class="flex-1 bg">
            <div class="notification-detail">
              <div class="title">
                {{ selectedNotification && selectedNotification.title }}
              </div>
              <div
                id="html-content"
                class="content"
                v-html="selectedNotification && selectedNotification.description"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

import { getNotification, makeReadNotification } from "@/services/notifications";

export default {
  name: "notification",
  data() {
    return {
      open: false,
      loader: false,
      openDetail: false,
      selectedNotificationId: 2,
      limitShowNotifications: 3,
      notifications: [],
      notificationsRender: [],
      updateNotifications: null
    };
  },
  computed: {
    notificationsToRead() {
      return this.notifications.filter(e => !e.read).length;
    },
    selectedNotification() {
      return this.notifications.find(n => n.id === this.selectedNotificationId);
    }
  },
  created() {
    const self = this;
    window.addEventListener("click", function(e) {
      // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.open = false;
      }
    });
  },
  mounted() {
    this.getNotifications();

    this.updateNotifications = setInterval(this.getNotifications, 1000 * 5 * 60);
  },
  watch: {
    notifications() {
      this.notificationsRender = this.notifications.slice(0, this.limitShowNotifications);
    },
    selectedNotificationId() {
      let notification = this.notifications.find(n => n.id === this.selectedNotificationId);
      if (notification && !notification.read) {
        this.makeReadNotification(this.selectedNotificationId);
      }
    }
  },
  destroyed() {
    window.removeEventListener("click", null);
    clearInterval(this.updateNotifications);
  },
  methods: {
    setOpen() {
      if (this.disabled) {
        return;
      }

      if (this.openDetail) {
        this.openDetail = !this.openDetail;
        return;
      }

      this.open = !this.open;
    },
    closeDetail() {
      this.openDetail = false;
      this.selectedNotificationId = null;
    },
    formatDate(date) {
      let dt = moment(date);
      let now = moment();

      let diff = moment.duration(now.diff(dt));

      return diff.asSeconds();
    },
    getNotifications() {
      getNotification()
        .then(repNotification => {
          this.notifications = repNotification;
        })
        .catch(error => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar notificações"
          });
        });
    },
    makeReadNotification(notificationId) {
      if (!notificationId) {
        return;
      }

      makeReadNotification(notificationId)
        .then(() => {
          let index = this.notifications.findIndex(n => n.id === notificationId);
          this.notifications[index].read = true;

          this.notifications = this.$ObjectCopy(this.notifications);
        })
        .catch(error => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Falhou ao tentar marcar notificação como lida."
          });
        });
    },
    viewAllNotification() {
      this.open = false;
      this.openDetail = true;
      this.selectedNotificationId =
        this.notifications && this.notifications.length > 0 && this.notifications[0].id;
      this.selectedNotification;
    }
  }
};
</script>

<style lang="scss" scoped>

#notification-widget {
  position: relative;
  #show-all-msgs {
    &:hover {
      color: #fff;
    }
  }
  .detail {
    width: 800px;
    position: absolute;
    padding: 0;
    top: 40px;
    z-index: 2;
    left: -470px;
    max-height: auto;
    background: var(--boxbg);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    border-radius: 3px;

    .box-title {
      .button {
        padding: 2px 8px;
        font-size: 16px;
      }
    }

    .box-content {
      padding-top: 0px;
      padding-right: 0px;
      padding-left: 0px;
      padding-bottom: 0px;
    }

    .box-title {
      align-items: center;
      color: var(--primary);
      padding: 4px 8px;;
      .button {
        .secondary {
          :hover {
            color: #fff !important;
          }
        }
      }
    }

    .list-detail {
      overflow-y: auto;
      overflow-x: hidden;
      height: 450px;
      // margin-bottom: 15px;

      z-index: 2;
      li {
        padding: 4px 10px;
        font-size: 1.4rem;
        display: block;
        cursor: pointer;
        transition: 0.15s;
        opacity: 0.8;
        + li {
          border-top: 1px solid rgba(#888, 0.1);
        }

        &.active {
          background: #ff131729;
        }

        &:empty {
          display: none;
        }
        &:hover {
          color: var(--primary);
          opacity: 1;
        }

        &.remove {
          background: rgba(#000, 0.02);
          border-bottom: 1px solid var(--border);
        }
      }

      .button {
        .secondary {
          :hover {
            color: #fff !important;
          }
        }
      }
    }

    .bg {
      background: var(--boxbg);
    }

    .notification-detail {
      overflow-y: auto;
      overflow-x: hidden;
      height: 450px;
      padding-top: 15px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 15px;
      margin-bottom: 15px;
      text-align: justify;
      font-size: 1.4rem;
      border-left: 1px solid #c2c2c2;

      .title {
        border-bottom: 1px solid var(--border);
        padding-bottom: 5px;
        font-weight: 700;
        // color: var(--primary);
      }
      .content {
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }

  .notification {
    flex: 1;
    align-items: center;
    justify-content: start;

    .avatar {
      display: flex;
      flex-direction: column;
      text-align: center;
      img {
        flex: 1;
        max-width: 60px;
        max-height: 60px;
        border-radius: 50%;
      }
    }
    .content {
      margin-left: 10px;
      // border-left: 1px solid rgba(167, 167, 167, 0.1);
      padding-left: 10px;
      border-left: 1px solid #3333330d;
      .description {
        font-size: 11px;
        margin-top: 5px;
        max-height: 50px;
        overflow: hidden;
      }
    }
    .created {
      width: 100%;
      margin-top: 5px;
      font-size: 9px;
    }
  }

  .list {
    position: absolute;
    padding: 0;
    top: 40px;
    left: -20px;
    max-height: 550px;
    width: 350px;
    overflow-y: auto;
    overflow-x: hidden;
    background: var(--boxbg);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    //border: 1px solid #dfdfdf;
    z-index: 2;
    li {
      padding: 14px 18px;
      font-size: 1.4rem;
      display: block;
      cursor: pointer;
      transition: 0.15s;
      opacity: 0.8;
      + li {
        border-top: 1px solid rgba(#888, 0.1);
      }

      &:empty {
        display: none;
      }
      &:hover {
        color: var(--primary);
        opacity: 1;
      }

      &.remove {
        background: rgba(#000, 0.02);
        border-bottom: 1px solid var(--border);
      }
    }

    .button {
      .secondary {
        :hover {
          color: #fff;
        }
      }
    }
  }
  .filter {
    position: relative;
    min-height: 42px;
    display: flex;
    align-items: center;
    min-width: 200px;
    cursor: pointer;
  }

  i {
    margin-top: 2px;
    float: right;
  }
}

.notification-button {
    position: relative;
    cursor: pointer;
    margin-right: 8px;
    margin-left: 8px;
}
</style>
